import { __assign, __extends } from "tslib";
// DS: I136
// from GDrive
import React from 'react';
import IconWrap from '../IconWrap';
var instances = 0;
var AddedToFav = /** @class */ (function (_super) {
    __extends(AddedToFav, _super);
    function AddedToFav() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.instanceId = instances++;
        return _this;
    }
    AddedToFav.prototype.render = function () {
        return (React.createElement(IconWrap, __assign({}, this.props),
            React.createElement("svg", { width: "0", height: "0", viewBox: "0 0 24 24", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
                React.createElement("defs", null,
                    React.createElement("path", { id: "i136-a-" + this.instanceId, d: "M11.23 19.98l-5.704 2.835 1.09-6.003L2 12.56l6.378-.876 2.853-5.462 2.852 5.462 6.379.876-4.616 4.252 1.09 6.003-5.705-2.835zm8.462-17.647H22V3.89h-2.308v2.333h-1.538V3.89h-2.308V2.333h2.308V0h1.538v2.333z" })),
                React.createElement("g", { fill: "none", fillRule: "evenodd" },
                    React.createElement("mask", { id: "i136-b-" + this.instanceId, fill: "#fff" },
                        React.createElement("use", { xlinkHref: "#i136-a-" + this.instanceId })),
                    React.createElement("g", { fill: "currentColor", mask: "url(#i136-b-" + this.instanceId + ")" },
                        React.createElement("path", { d: "M0 0h24v24H0z" }))))));
    };
    return AddedToFav;
}(React.Component));
export { AddedToFav };
export default AddedToFav;
//# sourceMappingURL=AddedToFav.js.map